var React = require('react');

function BulletXOrange (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.81,22H20.65a2.79,2.79,0,0,0,1.86-.71l9.24-8.19a2.81,2.81,0,0,0,0-4.2L22.51.71A2.79,2.79,0,0,0,20.65,0H2.81A2.81,2.81,0,0,0,0,2.81V19.19A2.81,2.81,0,0,0,2.81,22Z","style":{"fill":"#e74f3d"},"key":0}),React.createElement("path",{"d":"M16.05,15.25a1,1,0,0,0,.3-.72.94.94,0,0,0-.3-.7L13.23,11l2.82-2.83a.94.94,0,0,0,.3-.7,1,1,0,0,0-.3-.72l-1.4-1.4a1,1,0,0,0-.72-.3.94.94,0,0,0-.7.3L10.4,8.17,7.58,5.35a1,1,0,0,0-1.43,0l-1.4,1.4a1,1,0,0,0-.3.72.94.94,0,0,0,.3.7L7.58,11,4.75,13.83a.94.94,0,0,0-.3.7,1,1,0,0,0,.3.72l1.4,1.4a1,1,0,0,0,1.43,0l2.82-2.82,2.83,2.82a.94.94,0,0,0,.7.3,1,1,0,0,0,.72-.3l1.4-1.4Z","style":{"fill":"#fff"},"key":1})]);
}

BulletXOrange.defaultProps = {"viewBox":"0 0 32.69 22"};

module.exports = BulletXOrange;

BulletXOrange.default = BulletXOrange;
